import { Badge, Table } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

type LicenseAddonsProps = {
  extraStreams?: number
  extraVlmStreams?: number
  hasVlmAgents?: boolean
}

export const LicenseAddons = ({
  extraStreams,
  extraVlmStreams,
  hasVlmAgents
}: LicenseAddonsProps) => {
  return (
    <Table
      variant="vertical"
      layout="fixed"
      verticalSpacing="sm"
      horizontalSpacing="md"
      withTableBorder
    >
      <Table.Tbody>
        {!!extraStreams && extraStreams > 0 && (
          <Table.Tr>
            <Table.Th w={240}>
              <FormattedMessage id="subscriptions.addons.extraCameraStreams" />
            </Table.Th>

            <Table.Td>
              <Badge>{extraStreams}</Badge>
            </Table.Td>
          </Table.Tr>
        )}

        {!!extraVlmStreams && extraVlmStreams > 0 && (
          <Table.Tr>
            <Table.Th w={240}>
              <FormattedMessage id="subscriptions.addons.extraVlmStreams" />
            </Table.Th>

            <Table.Td>
              <Badge>{extraVlmStreams}</Badge>
            </Table.Td>
          </Table.Tr>
        )}

        {hasVlmAgents && (
          <Table.Tr>
            <Table.Th w={240}>
              <FormattedMessage id="subscriptions.addons.vlmAgents" />
            </Table.Th>

            <Table.Td>
              <Badge color="green">
                <FormattedMessage id="subscriptions.addons.included" />
              </Badge>
            </Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  )
}
